import {
    // FILE_UPLOAD,
    CREATE_ARCHITECTURESERVERLEADS,
    RETRIEVE_ARCHITECTURESERVERLEADS,
    RETRIEVE_ARCHITECTURESERVERCONVERTEDLEADS,
    RETRIEVE_ARCHITECTURESERVERPENDINGLEADS,
    RETRIEVESINGLE_ARCHITECTURESERVERLEADS,
    UPDATE_ARCHITECTURESERVERLEADS,
    DELETE_ARCHITECTURESERVERLEADS,
} from "./type";
import ARCServerLeads from "../service/arcServerLeads";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await ARCServerLeads.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await ARCServerLeads.create(data);
        dispatch({
            type: CREATE_ARCHITECTURESERVERLEADS,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await ARCServerLeads.fetchList(data);
        dispatch({
            type: RETRIEVE_ARCHITECTURESERVERLEADS,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrievePending = (data) => async (dispatch) => {
    try {
        const res = await ARCServerLeads.fetchPendingList(data);
        dispatch({
            type: RETRIEVE_ARCHITECTURESERVERPENDINGLEADS,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveConverted = (data) => async (dispatch) => {
    try {
        const res = await ARCServerLeads.fetchConvertedList(data);
        dispatch({
            type: RETRIEVE_ARCHITECTURESERVERCONVERTEDLEADS,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await ARCServerLeads.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_ARCHITECTURESERVERLEADS,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await ARCServerLeads.update(data);
        dispatch({
            type: UPDATE_ARCHITECTURESERVERLEADS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await ARCServerLeads.changeStatus(data);
//         dispatch({
//             type: UPDATE_ARCHITECTURESERVERLEADS,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await ARCServerLeads.trash(data);
        dispatch({
            type: DELETE_ARCHITECTURESERVERLEADS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};